import { getReverseProposalGoodsDetail as getReverseProposalGoodsDetailApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetReverseProposalGoodsDetailServiceRequest,
  GetReverseProposalGoodsDetailServiceResponse,
} from './get-reverse-proposal-goods-detail.dto';
import {
  GetReverseProposalGoodsDetailServiceRequestSchema,
  GetReverseProposalGoodsDetailServiceResponseSchema,
} from './get-reverse-proposal-goods-detail.dto';

export const getReverseProposalGoodsDetailService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetReverseProposalGoodsDetailServiceRequestSchema),
    async (
      request: GetReverseProposalGoodsDetailServiceRequest,
    ): Promise<GetReverseProposalGoodsDetailServiceResponse> => {
      const apiResponse = await getReverseProposalGoodsDetailApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '상품 상세 조회에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(GetReverseProposalGoodsDetailServiceResponseSchema),
  ),
);
